import { Injectable } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MutasiAntarCounterService {

  constructor(private httpService: HttpService) { }

  getMutationList(params: any): Observable<any> {
    return this.httpService.get('mutasi-antar-counter', params);
  }
  getForMutationForm(params: any): Observable<any> {
    return this.httpService.get('mutasi-antar-counter/create', params);
  }
  submitForm(params: any): Observable<any> {
    return this.httpService.post('mutasi-antar-counter', params);
  }

  getMutationById(id:any,params: any): Observable<any> {
    return this.httpService.get('mutasi-antar-counter/'+id, params);
  }
  getStockForMutation(params: any): Observable<any> {
    return this.httpService.post('get-stock-for-mutation', params);
  }
  updateStatus(params: any): Observable<any> {
    return this.httpService.post('update-mutasi-antar-counter', params);
  }
}
